import { ErrorState } from "../../pages/Contact/MainDataTable";

 

export const apiResponseHandler = (response: any, forToaster: boolean) => {
    let error: ErrorState | null = null;

    if (!response || response.code === "ERR_NETWORK" || response.message === "network error") {
        error = {
            code: response?.code || "502",
            message: response?.message || "Hang tight! Our checkout lanes are undergoing maintenance. We'll be back soon!",
        }
        return error;
    }

    if (response.response) {
        const {status, message} = response.response;

        const errorMessages: Record<number, string> = {
            400: "Oops, your request got lost in translation! Maybe try again with simpler instructions?",
            404: "Oopsie! Looks like this page went on vacation. Maybe try a different path?",
            500: "Uh-oh, our server's taking a coffee break. It'll be back to ringing up sales soon!",
            502: "Hang tight! Our checkout lanes are undergoing maintenance. We'll be back soon!"
        };

        if ([400, 404, 500, 502].includes(status)) {
            error = {
                code: status.toString(),
                message: message || errorMessages[status] || "Something went wrong.",
            };
            return error;
        }
    }
    if (!response.data.status) {
        const pageMessages: Record<string, string> = {
            "401": "Sorry, this area's VIP only. Your pass must've gotten lost in the mail.",
            "404": "Oopsie! Looks like this page went on vacation. Maybe try a different path?",
            "429": "Limit Reach: Looks like we've hit the digital highway's speed limit. Time for a pit stop to refuel.",
            "500": "Uh-oh, our server's taking a coffee break. It'll be back to ringing up sales soon!",
        };

        const toasterMessages: Record<string, string> = {
            "401": "Access denied",
            "404": response.data.response || "Not found",
            "429": response.data.response || "Too many requests",
            "500": response.data.response || "Server error",
        };

        const messages = forToaster ? toasterMessages : pageMessages;

        error = {
            code: response.data.code == 401 ? "200" : response.data.code,
            message: messages[response.data.code] || "Something went wrong.",
        };
        return error;
    }
    return error;
}